.vendor-lead-step-start__layout {
  flex: 1;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: stretch;
}

.vendor-lead-step-start__layout .vendor-lead-step-start__layout__left {
  flex: 1;
}

.vendor-lead-step-start__layout .vendor-lead-step-start__layout__center {
  flex: 3;
  margin-right: 42px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  align-items: flex-start;
}

.vendor-lead-step-start__layout .vendor-lead-step-start__layout__right {
  flex: 4;
}

.vendor-lead-step-start__layout .vendor-lead-step-start__layout__center__header {
  margin-top: 62px;
}

.vendor-lead-step-start__layout__center__header .vendor-lead-step-start__layout__center__header__logo {
  position: relative;

  width: 154px; // logo text width + logo text left
}

.vendor-lead-step-start__layout__center__header .vendor-lead-step-start__layout__center__header__logo-icon {
  border-radius: 50%;
  width: 40px;
  height: 40px;

  background-color: #22BDFF;
}

.vendor-lead-step-start__layout__center__header .vendor-lead-step-start__layout__center__header__logo-text {
  position: absolute;

  top: 14px;
  left: 10px;

  height: 14px;
  width: 140px;
}

.vendor-lead-step-start__layout__center .vendor-lead-step-start__layout__center__content {
  flex: 1;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: stretch;

  gap: 16px;
}

.vendor-lead-step-start__layout__center .vendor-lead-step-start__layout__center__title {
  font-size: 30px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.75px;

  text-align: left;
}

.vendor-lead-step-start__layout__center .vendor-lead-step-start__layout__center__text {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.vendor-lead-step-start__layout  .vendor-lead-step-start__video-container {
  width: 100%;
  height: 100%;

  display: flex;
  flex-flow: column nowrap;
  justify-content: stretch;
  align-items: stretch;

  & video {
    object-fit: cover;
    object-position: center;

    width: 100%;
    height: 100%;
  }
}

.vendor-lead-step-start__layout__center .vendor-lead-step-start__layout__center__footer {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.vendor-lead-step-start__layout__center .vendor-lead-step-start__layout__center__footer__start-button {
  margin-left: auto;

  display: flex;
  flex-flow: row-reverse nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

@media screen and (width <= 640px) {
  .vendor-lead-step-start__layout {
    padding: 16px;
  }

  .vendor-lead-step-start__layout .vendor-lead-step-start__layout__left {
    display: none;
  }

  .vendor-lead-step-start__layout .vendor-lead-step-start__layout__center {
    margin-right: 0;
  }

  .vendor-lead-step-start__layout .vendor-lead-step-start__layout__right {
    display: none;
  }

  .vendor-lead-step-start__layout .vendor-lead-step-start__layout__center__header {
    margin-top: 0;

    align-self: stretch;

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
  }

  .vendor-lead-step-start__layout__center .vendor-lead-step-start__layout__center__footer {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-step-start__layout__center .vendor-lead-step-start__layout__center__footer__start-button {
    align-self: flex-end;
  }
}
